import React from "react";
import { useSelector } from "react-redux";
import Typography from "@mui/material/Typography";
import { Gauge, gaugeClasses } from "@mui/x-charts/Gauge";
import WidgetTemplate from "../../widgets/WidgetTemplate";
import { RootState } from "../../../app/store";
import { toDate } from "../../../utils/TimeUtils";
import { MIN_VOLTAGE, MAX_VOLTAGE } from "./VoltageCard";

const BatteryWidget = React.memo((props: any) => {

    const { id, gridId, reduced, params, width, height } = props;

    const stream = useSelector((state: RootState) => {
        const currentTime = state.replay.currentTime;
        const currentTS = toDate(currentTime).getTime() / 1000;

        const stream = state.telemetry.streams[params.source]?.[params.label];
        const currentTimestamps = stream ?
            currentTS ?
                stream[0].filter(timestamp => timestamp <= currentTS)
            : stream[0]
        : null;
        const currentStream = currentTimestamps ? [currentTimestamps, stream[1].slice(0, currentTimestamps.length)] : null;
        
        return currentStream;
    });
    
    const frame = stream && stream[0]?.[0] ? {...stream[1].slice(-1)[0], updated: toDate(stream[0].slice(-1)[0])} : null; // getting last data frame from stream
    const value = frame ? Number(frame.batteryVoltage) : null;

    return (
        <WidgetTemplate
            id={id}
            gridId={gridId}
            header={`${params.name} - Battery`}
            actions={[]}
            width={width}
            height={height}
            reduced={reduced}
        >
            {value ?
                <>
                    <Gauge
                        value={value < MIN_VOLTAGE ? MIN_VOLTAGE : value > MAX_VOLTAGE ? MAX_VOLTAGE : value}
                        valueMin={MIN_VOLTAGE}
                        valueMax={MAX_VOLTAGE}
                        startAngle={-110}
                        endAngle={110}
                        text={() => `${Number(value.toFixed(2))} V`}
                        sx={{
                            [`& .${gaugeClasses.valueArc}`]: {
                                fill: value < 3.7 ? "red" : value < 3.8 ? "orange" : "limegreen"
                            },
                            fontSize: 20
                        }}
                    />
                </>
            : <Typography variant="h6" color="text.secondary" sx={{marginTop: 1, marginLeft: 2, maxHeight: "90%", maxWidth: "90%"}}>No data available</Typography>
            }
        </WidgetTemplate>
    );
});

export default BatteryWidget;